export type AnalyticsEvent =
  | "experiment_opened"
  | "entry_visible"
  | "merge_started"
  | "merge_completed"
  | "lane_changed"
  | "horn_used"
  | "reaction_used"
  | "garage_opened"
  | "checkout_started"
  | "checkout_completed"
  | "garage_restored"
  | "exit_started"
  | "trip_report_viewed"
  | "share_clicked"
  | "share_completed"
  | "referral_opened"
  | "realtime_degraded"
  | "performance_tier_changed";

export type SafeAnalyticsProperties = Record<
  string,
  boolean | number | string | null
>;

export type AnalyticsAdapter = {
  track(event: AnalyticsEvent, properties?: SafeAnalyticsProperties): void;
};

class NoopAnalyticsAdapter implements AnalyticsAdapter {
  public track(): void {
    // Intentionally empty: local mode never sends analytics.
  }
}

export const analytics: AnalyticsAdapter = new NoopAnalyticsAdapter();
